var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17.707,
    viewBox: "0 0 16 17.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-share",
    "data-name": "Icon material-share",
    d: "M17.833,15.516a2.588,2.588,0,0,0-1.742.684L9.753,12.511a2.46,2.46,0,0,0,0-1.244L16.02,7.613a2.661,2.661,0,1,0-.853-1.947,2.91,2.91,0,0,0,.08.622L8.98,9.942a2.667,2.667,0,1,0,0,3.893l6.329,3.7a2.508,2.508,0,0,0-.071.578,2.6,2.6,0,1,0,2.6-2.6Z",
    transform: "translate(-4.5 -3)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialShare);
export default __webpack_public_path__ + "static/media/material-share.74da4a0b6bd47cb060286aa8f94769e3.svg";
export { ForwardRef as ReactComponent };